import { FaCreditCard, FaBook, FaBriefcase } from "react-icons/fa";
import React from "react";
export const products = [
  {
    id: 1,
    title: "Samsung Galaxy S7",
    price: 600,
    img:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1583368215/phone-2_ohtt5s.png",
    amount: 1,
  },
  {
    id: 2,
    title: "google pixel ",
    price: 500,
    img:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1583371867/phone-1_gvesln.png",
    amount: 1,
  },
  {
    id: 3,
    title: "Xiaomi Redmi Note 2",
    price: 700,
    img:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1583368224/phone-3_h2s6fo.png",
    amount: 1,
  },
];

export const sublinks = [
  {
    page: "products",
    links: [
      { label: "payment", icon: <FaCreditCard />, url: "/products" },
      { label: "terminal", icon: <FaCreditCard />, url: "/products" },
      { label: "connect", icon: <FaCreditCard />, url: "/products" },
    ],
  },
  {
    page: "developers",
    links: [
      { label: "plugins", icon: <FaBook />, url: "/products" },
      { label: "libraries", icon: <FaBook />, url: "/products" },
      { label: "help", icon: <FaBook />, url: "/products" },
      { label: "billing", icon: <FaBook />, url: "/products" },
    ],
  },
  {
    page: "company",
    links: [
      { label: "about", icon: <FaBriefcase />, url: "/products" },
      { label: "customers", icon: <FaBriefcase />, url: "/products" },
    ],
  },
];

export const people = [
  {
    id: 1,
    name: "susan smith",
    job: "web developer",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg",
    text:
      "I'm baby meggings twee health goth +1. Bicycle rights tumeric chartreuse before they sold out chambray pop-up. Shaman humblebrag pickled coloring book salvia hoodie, cold-pressed four dollar toast everyday carry",
  },
  {
    id: 2,
    name: "anna johnson",
    job: "web designer",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883409/person-2_np9x5l.jpg",
    text:
      "Helvetica artisan kinfolk thundercats lumbersexual blue bottle. Disrupt glossier gastropub deep v vice franzen hell of brooklyn twee enamel pin fashion axe.photo booth jean shorts artisan narwhal.",
  },
  {
    id: 3,
    name: "peter jones",
    job: "intern",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg",
    text:
      "Sriracha literally flexitarian irony, vape marfa unicorn. Glossier tattooed 8-bit, fixie waistcoat offal activated charcoal slow-carb marfa hell of pabst raclette post-ironic jianbing swag.",
  },
  {
    id: 4,
    name: "bill anderson",
    job: "the boss",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883423/person-4_t9nxjt.jpg",
    text:
      "Edison bulb put a bird on it humblebrag, marfa pok pok heirloom fashion axe cray stumptown venmo actually seitan. VHS farm-to-table schlitz, edison bulb pop-up 3 wolf moon tote bag street art shabby chic. ",
  },
];

export const people1 = [
  {
    id: 1,
    name: "Brian Tracy",
    title: "Software engineer",
    img: "/static/media/pic1.dec30687.png",
    quote:
      "Lorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },

  {
    id: 2,
    name: "Karl Max",
    title: "Inventor",
    img: "/static/media/pic2.5f6b3aa1.png",
    quote:
      "Lorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 3,
    name: "John Doe",
    title: "Sculptor",
    img: "/static/media/pic3.c3bd31b9.png",
    quote:
      "firstLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
];

export const questions = [
  {
    id: 1,

    title: "Who is a Software engineer?",
    info:
      "firstLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },

  {
    id: 2,
    title: "Is React needed to be a Frontend Developer?",
    info:
      "SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 3,
    title: "Is Vue needed to be a Frontend Developer?",
    info:
      "ThirdLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 4,
    title: "Is Angular needed to be a Frontend Developer?",
    info:
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
];

export const Word = [
  "SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",

  "ThirdLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",

  "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",

  "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",

  "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjdFourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
];

export const meals = [
  {
    id: 1,

    title: "Fried Rice",
    category: "breakfast",
    info:
      "firstLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },

  {
    id: 2,
    title: "Cat-fish PepperSoup",
    category: "lunch",
    info:
      "SecondLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 3,
    title: "Vegetable Soup",
    category: "dinner",
    info:
      "ThirdLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 4,
    title: "Bread and egg",
    category: "breakfast",
    info:
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 5,
    title: "Egusi & Wheat",
    category: "Brunch",
    info:
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 6,
    title: "Fruit- Salad",
    category: "Deserts",
    info:
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
  },
  {
    id: 7,
    title: "Snacks",
    category: "Night-Cap",
    info: [
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "urthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "efcfssrthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
    ],
  },
];

export const Profile = [
  {
    id: 1,
    title: "Frontend",

    info: [
      "FourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "urthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "efcfssrthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
    ],
  },

  {
    id: 2,
    title: "Backend",

    info: [
      "ddfourthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "ffethLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "deeecfssrthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
    ],
  },
  {
    id: 3,
    title: "Design",

    info: [
      "frthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "hhgfrthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
      "efswwcfssrthLorem Ipsum hdhfhf shhshd jfjfj sjsjdn djfj sdjfj sjdjd sjjdj sjdjcdjd ddc cjd",
    ],
  },
];
